'use es6';

export const generateConversationInboxLabel = conversationInbox => {
  return conversationInbox.get('hs_inbox_name');
};